import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/trading/take-profit.md?raw';

const TradingTakeProfit: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default TradingTakeProfit;
